/* src/app/components/master-detail-cdc-authorization/components/cdc-3ds/cdc-3ds.component.scss */
:host {
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
}
.tds-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 0 var(--yf-spacing1, 12px) var(--yf-spacing1, 12px);
  box-sizing: border-box;
}
.tds-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: var(--yf-spacing1, 12px);
  color: var(--ion-color-secondary);
}
.tds-bar .tds-title {
  font-weight: 600;
  font-size: 15px;
  flex: 1;
}
.tds-bar .tds-close {
  --padding-start: 4px;
  --padding-end: 4px;
  margin: 0;
}
.tds-frame {
  position: relative;
  flex: 1;
  min-height: 0;
  border-radius: var(--yf-border-radius, 12px);
  overflow: hidden;
  background: var(--ion-background-color, #fff);
  box-shadow: var(--yf-shadow, 5px 5px 10px rgba(0, 0, 0, 0.1215686275));
}
.tds-frame iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
  -webkit-overflow-scrolling: touch;
}
.tds-frame .tds-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
}
.tds-foot {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: var(--yf-spacing1, 12px);
}
.tds-foot .tds-hint {
  margin: 0;
  font-size: 13px;
  text-align: center;
  opacity: 0.7;
  max-width: 320px;
}
.tds-slow {
  margin: 0 0 6px;
  font-size: 13px;
  text-align: center;
  max-width: 340px;
  color: var(--ion-color-warning-shade, #b26a00);
}
.tds-loading-copy {
  position: absolute;
  left: 50%;
  top: calc(50% + 34px);
  transform: translateX(-50%);
  width: 88%;
  max-width: 320px;
  text-align: center;
  font-size: 13px;
  opacity: 0.75;
  margin: 0;
}
/*# sourceMappingURL=cdc-3ds.component.css.map */
